import { Link, useLocation } from '@tanstack/react-router';
import { ApiMenuItem } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IMenuItem {
    item: ApiMenuItem;
}

const MenuItem = ({ item }: IMenuItem) => {
    const location = useLocation();
    return (
        <>
            <Link
                onClick={() => $('body').removeClass('is-nav-mobile-active')}
                to={'/$'}
                params={{ _splat: item.url ?? '/' }}
                className='nav-link'
            >
                {item.name}
            </Link>
            {item.url && location.pathname.includes(item.url) && item.children && item.children?.length > 0 && (
                <ul className={`nav-main-sub`}>
                    {item.children.map((menuChildItem, childKey) => {
                        if (!menuChildItem.url) return null;
                        return (
                            <li key={childKey}>
                                <Link
                                    onClick={() => $('body').removeClass('is-nav-mobile-active')}

                                    to={'/$'}
                                    params={{ _splat: menuChildItem.url }}
                                    className='nav-link'
                                >
                                    {menuChildItem.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default MenuItem;
